import './MembershipPackUI.scss';

export const membershipDetailUrl = (planId, companyId) => {
  if (!planId) return '';

  const query = companyId ? `?companyId=${encodeURIComponent(companyId)}` : '';
  return `/memberships/${encodeURIComponent(planId)}${query}`;
};

const MembershipPackUI = ({plan, companyId}) => {
  const planName = plan?.planName || 'Membership Plan';
  const detailUrl = membershipDetailUrl(plan?.planId, companyId);

  if (!detailUrl) return null;

  return (
    <div className="membership-package-tile">
      <a
        aria-label={`Learn more about the ${planName} membership`}
        className="card rounded-3 shadow-sm membership-package-card"
        href={detailUrl}
        rel="noopener noreferrer"
        target="_blank"
      >
        <div className="card-header py-3 bg-dark">
          <h4 className="my-0 fw-normal text-white fs-5 membership-package-card__banner">
            {planName}
          </h4>
        </div>
        <div className="card-body membership-package-card__body">
          <p>The {planName} membership includes this service.</p>
          <span className="membership-package-card__link">Click here to learn more.</span>
        </div>
      </a>
    </div>
  );
};

export default MembershipPackUI;
